import {Control} from 'ol/control.js';
import Draw from 'ol/interaction/Draw.js';
import Overlay from 'ol/Overlay.js';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style.js';
import {LineString, Polygon} from 'ol/geom.js';
import {Vector as VectorSource} from 'ol/source.js';
import {Vector as VectorLayer} from 'ol/layer.js';
import {getArea, getLength} from 'ol/sphere.js';
import {unByKey} from 'ol/Observable.js';

class MeasureLine extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const button = document.createElement('button');
    const tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Medir';
    button.title = tipLabel;

    const element = document.createElement('div');
    element.className = 'measure-line-control ol-unselectable ol-control';
    element.appendChild(button);

    super({element: element, target: options.target});
    this.vectorSource = new VectorSource();
    this.vectorLayer = new VectorLayer({
      source: this.vectorSource,
      style: new Style({
        fill: new Fill({color: 'rgba(255, 255, 255, 0.2)'}),
        stroke: new Stroke({color: '#ffcc33', width: 2}),
        image: new CircleStyle({
          radius: 7,
          fill: new Fill({color: '#ffcc33'}),
        }),
      }),
    });
    this.draw = null;
    this.measureTooltipElement = null;
    this.helpTooltipElement = null;
    this.active = false;

    button.addEventListener('click', this.toggleMeasurement.bind(this), false);
  }

  toggleMeasurement() {
    if (!this.active) {
      this.getMap().addLayer(this.vectorLayer);
      this.addInteraction();
      this.active = true;
      this.element.classList.add('activo')
    } else {
      this.getMap().removeLayer(this.vectorLayer);
      this.getMap().removeInteraction(this.draw);
      this.element.classList.remove('activo')

      this.vectorSource.clear();

      this.draw=null;
      this.measureTooltipElement = null;
      this.helpTooltipElement = null;

      const measureElements =document.querySelectorAll('.ol-tooltip.ol-tooltip-static')
      measureElements.forEach(element => {
        element.remove();
      });

      this.active = false;
    }
  }

  addInteraction() {
    //tipo
    //const type = document.getElementById('type').value === 'area' ? 'Polygon' : 'LineString';
    const type = 'LineString';
    this.draw = new Draw({
      source: this.vectorSource,
      type: type,
    });
    this.getMap().addInteraction(this.draw);
    this.createMeasureTooltip();
    this.createHelpTooltip();

    let listener;
    this.draw.on('drawstart', (evt) => {
      this.sketch = evt.feature;
      let tooltipCoord = evt.coordinate;

      listener = this.sketch.getGeometry().on('change', (evt) => {
        const geom = evt.target;
        let output;
        if (geom instanceof Polygon) {
          output = this.formatArea(geom);
          tooltipCoord = geom.getInteriorPoint().getCoordinates();
        } else if (geom instanceof LineString) {
          output = this.formatLength(geom);
          tooltipCoord = geom.getLastCoordinate();
        }
        this.measureTooltipElement.innerHTML = output;
        this.measureTooltip.setPosition(tooltipCoord);
      });
    });

    this.draw.on('drawend', () => {
      this.measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
      this.measureTooltip.setOffset([0, -7]);
      this.sketch = null;
      this.measureTooltipElement = null;
      this.createMeasureTooltip();
      unByKey(listener);
    });
  }

  createHelpTooltip() {
    if (this.helpTooltipElement) {
      this.helpTooltipElement.remove();
    }
    this.helpTooltipElement = document.createElement('div');
    this.helpTooltipElement.className = 'ol-tooltip hidden';
    this.helpTooltip = new Overlay({
      element: this.helpTooltipElement,
      offset: [15, 0],
      positioning: 'center-left',
    });
    this.getMap().addOverlay(this.helpTooltip);
  }

  createMeasureTooltip() {
    if (this.measureTooltipElement) {
      this.measureTooltipElement.remove();
    }
    this.measureTooltipElement = document.createElement('div');
    this.measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
    this.measureTooltip = new Overlay({
      element: this.measureTooltipElement,
      offset: [0, -15],
      positioning: 'bottom-center',
      stopEvent: false,
      insertFirst: false,
    });
    this.getMap().addOverlay(this.measureTooltip);
  }

  formatLength(line) {
    const length = getLength(line);
    return length > 100
      ? `${Math.round((length / 1000) * 100) / 100} km`
      : `${Math.round(length * 100) / 100} m`;
  }

  formatArea(polygon) {
    const area = getArea(polygon);
    return area > 10000
      ? `${Math.round((area / 1000000) * 100) / 100} km²`
      : `${Math.round(area * 100) / 100} m²`;
  }
}

export default MeasureLine;
